(function(){
  const key='shredded-babes-brand';
  const valid=(value)=>value==='denim'||value==='digital';
  function saved(){try{const value=localStorage.getItem(key);return valid(value)?value:'digital'}catch(error){return'digital'}}
  function mark(){
    const main=document.getElementById('MainContent');
    if(!main)return;
    const denimDivider=main.querySelector('[data-sb-brand-marker="denim"]');
    if(!denimDivider){
      document.body.classList.remove('sb-homepage-mode');
      main.querySelectorAll('[data-sb-home-brand]').forEach((section)=>section.removeAttribute('data-sb-home-brand'));
      return;
    }
    document.body.classList.add('sb-homepage-mode');
    let brand='digital';
    Array.from(main.children).forEach((section)=>{
      if(section.querySelector('[data-sb-brand-marker="denim"]'))brand='denim';
      section.dataset.sbHomeBrand=brand;
    });
  }
  function bindMobileNavigation(menu){
    const drawer=menu&&menu.closest('header-drawer');
    if(!drawer||typeof drawer.onSummaryClick!=='function')return;
    menu.querySelectorAll('summary').forEach((summary)=>{
      summary.setAttribute('role','button');
      summary.setAttribute('aria-expanded',String(summary.parentNode.hasAttribute('open')));
      if(summary.nextElementSibling&&summary.nextElementSibling.id)summary.setAttribute('aria-controls',summary.nextElementSibling.id);
      summary.addEventListener('click',drawer.onSummaryClick.bind(drawer));
    });
    if(typeof drawer.onCloseButtonClick==='function'){
      menu.querySelectorAll('.menu-drawer__close-button').forEach((button)=>{
        button.addEventListener('click',drawer.onCloseButtonClick.bind(drawer));
      });
    }
  }
  function swapNavigation(brand){
    const desktopTemplate=document.querySelector(`[data-sb-navigation="${brand}-desktop"]`);
    const desktopSource=desktopTemplate&&desktopTemplate.content.querySelector('nav.header__inline-menu > ul');
    const desktopTarget=document.querySelector('.section-header nav.header__inline-menu > ul');
    if(desktopSource&&desktopTarget&&desktopTarget.dataset.sbMenuBrand!==brand){desktopTarget.innerHTML=desktopSource.innerHTML;desktopTarget.dataset.sbMenuBrand=brand}
    const mobileTemplate=document.querySelector(`[data-sb-navigation="${brand}-mobile"]`);
    const mobileSource=mobileTemplate&&mobileTemplate.content.querySelector('ul.menu-drawer__menu.has-submenu');
    const mobileTarget=document.querySelector('.section-header header-drawer ul.menu-drawer__menu.has-submenu');
    if(mobileSource&&mobileTarget&&mobileTarget.dataset.sbMenuBrand!==brand){mobileTarget.innerHTML=mobileSource.innerHTML;mobileTarget.dataset.sbMenuBrand=brand;bindMobileNavigation(mobileTarget)}
  }
  function swapLogo(brand){
    const link=document.querySelector('.section-header .header__heading-link');
    const source=document.querySelector(`[data-sb-logo="${brand}"]`);
    if(!link||!source)return;
    if(!link.dataset.sbOriginalLogo)link.dataset.sbOriginalLogo=link.innerHTML;
    const url=source.dataset.logoUrl;
    if(!url){link.innerHTML=link.dataset.sbOriginalLogo;link.dataset.sbLogoBrand='original';link.dataset.sbLogoUrl='';return}
    if(link.dataset.sbLogoBrand===brand&&link.dataset.sbLogoUrl===url)return;
    const width=parseInt(source.dataset.logoWidth,10)||180;
    const alt=source.dataset.logoAlt||'Shredded Babes';
    const wrapper=document.createElement('div');
    wrapper.className='header__heading-logo-wrapper';
    wrapper.style.width=`${width}px`;
    wrapper.style.maxWidth='100%';
    const image=document.createElement('img');
    image.className='header__heading-logo motion-reduce';
    image.src=url;
    image.alt=alt;
    image.width=width;
    image.style.width='100%';
    image.style.height='auto';
    wrapper.appendChild(image);
    link.replaceChildren(wrapper);
    link.dataset.sbLogoBrand=brand;
    link.dataset.sbLogoUrl=url;
  }
  function apply(brand){document.body.dataset.sbBrand=brand;swapNavigation(brand);swapLogo(brand);document.querySelectorAll('[data-sb-brand-tab]').forEach((tab)=>{const active=tab.dataset.sbBrandTab===brand;tab.setAttribute('aria-selected',String(active));tab.classList.toggle('is-active',active)})}
  function change(brand){if(!valid(brand)||document.body.dataset.sbBrand===brand)return;const loader=document.querySelector('[data-sb-brand-loader]');if(loader)loader.classList.add('is-visible');window.setTimeout(()=>{try{localStorage.setItem(key,brand)}catch(error){}apply(brand);window.scrollTo({top:0,behavior:'instant'});window.setTimeout(()=>loader&&loader.classList.remove('is-visible'),420)},260)}
  function wording(){const source=document.querySelector('[data-sb-loader-wording]');const target=document.querySelector('.sb-brand-loader__text');if(source&&target)target.textContent=source.content.textContent.trim()||'SHREDDED BABES'}
  function init(){mark();wording();apply(saved());document.addEventListener('click',(event)=>{const tab=event.target.closest('[data-sb-brand-tab]');if(tab)change(tab.dataset.sbBrandTab)})}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();document.addEventListener('shopify:section:load',()=>{mark();wording();apply(saved())});
})();
